import React from "react";
import { useLanguageContext } from "../../../Context/LanguageContext";
import EquipmentGroupActions from "../../../Actions/EquipmentGroupActions";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import { MdFilterList } from "react-icons/md";
import { CiViewList } from "react-icons/ci";
export default function SelectedEquipmentGroups({
  selectedGroupIds,
  eqGrpList,
  onFilter,
  filterValues,
}) {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  if (!selectedGroupIds || selectedGroupIds.length === 0) {
    return null;
  }

  const selectedGroups = eqGrpList.filter((group) =>
    selectedGroupIds.includes(group.id)
  );

  function getFilterEqList(groupId, filters) {
    setGlobalSpinner(true);
    EquipmentGroupActions.getEquipmentList2(
      "EquipList",
      "asc",
      groupId,
      1,
      20,
      "inventry",
      null,
      filters || []
    );
  }

  return (
    <div className="mt-3">
      <div class="row mb-4 mt-4 pl-4 pt-2 pb-2 emailDistbutaion">
        <h2 className="emailDistbutaionH1">{localization.selectedEquipGrp}</h2>
      </div>
      <div
        className="container mw-100 containerInnerShadow"
        style={{
          minHeight: "10vh",
          maxHeight: "25vh",
          overflowY: "auto",
        }}
      >
        <table className="table table-striped">
          <thead>
            <tr>
              <th>{localization.equipmentGroupName}</th>
              <th>{localization.actions}</th>
            </tr>
          </thead>
          <tbody>
            {selectedGroups.map((group) => (
              <tr key={group.id}>
                <td>{group.bezeichnungsDisplay}</td>
                <td className="d-flex">
                  <MdFilterList
                    style={{ cursor: "pointer", marginRight: "10px" }}
                    size={20}
                    title={localization.filter}
                    onClick={() => onFilter(group.id)}
                  />
                  {(filterValues[group.id]?.length || 0) > 0 && (
                    <CiViewList
                      onClick={(e) => {
                        e.preventDefault();
                        getFilterEqList(group.id, filterValues[group.id]);
                      }}
                      data-toggle="modal"
                      data-target="#filterEquipmentlistpopOver"
                      title={localization.showEquipmentList}
                      style={{ cursor: "pointer" }}
                      size={20}
                    ></CiViewList>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
